<script lang="ts" setup>
import SidebarMobileNavItem from "./SidebarMobileNavItem.vue";

import type { SidebarNavItem } from "@/widgets/navigationSidebar/types";

interface Props {
  /** Navigation items */
  items: SidebarNavItem[]
}

defineProps<Props>();
</script>

<template>
  <nav
    aria-label="Mobile navigation"
    class="sidebar-mobile-nav flex-1 overflow-y-auto overflow-x-hidden px-3 py-4 space-y-1"
  >
    <SidebarMobileNavItem
      v-for="item in items"
      :key="item.id"
      :item="item"
    />
  </nav>
</template>
